import styled from "styled-components/macro";

export const StyledMetadataModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .failed-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0px 48px;
  }
`

export const StyledMetadataModalButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
